/* screens/broadcasts/BroadcastsScreen.jsx — модуль «Рассылки» в консоли /console.
   Список рассылок + создание/редактирование через дровер (BroadcastFormDrawer).
   Доступ — гейт RequireBroadcastsAccess (marketing.manage_broadcasts). */
import React from 'react';
import { PageHeader } from '../../components/patterns/PageHeader.jsx';
import { EmptyState, ErrorState } from '../../components/patterns/States.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { Spinner } from '../../components/ui/Spinner.jsx';
import { hooks } from '../../hooks/index.jsx';
import * as api from '../../lib/api/marketing.js';
import { BroadcastFormDrawer } from './BroadcastFormDrawer.jsx';

const { useState, useCallback } = React;
const { useFakeQuery } = hooks;

const STATUS_LABEL = {
  draft: 'Черновик', scheduled: 'Запланирована', processing: 'Отправляется',
  completed: 'Завершена', completed_with_errors: 'С ошибками', cancelled: 'Остановлена',
};

function fmtDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
}

function BroadcastsScreen() {
  const [nonce, setNonce] = useState(0);
  const [drawer, setDrawer] = useState(null); // {id} | {id:null} (new) | null
  const q = useFakeQuery('bcasts-' + nonce, () => api.listBroadcasts(), [nonce]);
  const items = q.data || [];

  const refresh = useCallback(() => setNonce((n) => n + 1), []);
  const openNew = () => setDrawer({ id: null });
  const openEdit = (b) => setDrawer({ id: b.id });
  const closeDrawer = () => { setDrawer(null); refresh(); };

  return (
    <div className="section-page">
      <PageHeader breadcrumbs={[{ label: 'Админка', to: '/console' }, { label: 'Рассылки' }]} title="Рассылки" />
      <div className="section-body">
        <div className="cluster cluster-8" style={{ marginBottom: 12 }}>
          <Button variant="primary" iconLeft="plus" onClick={openNew}>Создать рассылку</Button>
        </div>

        {q.loading ? (
          <div className="center pad-24"><Spinner /></div>
        ) : q.error ? (
          <ErrorState title="Не удалось загрузить" detail={String(q.error.detail || q.error)} onRetry={refresh} />
        ) : items.length === 0 ? (
          <EmptyState icon="send" title="Пока нет рассылок" detail="Создайте первую рассылку в Telegram и/или на почту." />
        ) : (
          <div className="bcast-table">
            <div className="bcast-row bcast-row--head">
              <span>Название</span><span>Статус</span><span>Каналы</span><span>Аудитория</span>
              <span>Прогресс</span><span>Когда</span>
            </div>
            {items.map((b) => (
              <button type="button" key={b.id} className="bcast-row" onClick={() => openEdit(b)}>
                <span className="bcast-row__title">{b.title}</span>
                <span><span className={'bcast-badge bcast-badge--' + b.status}>{STATUS_LABEL[b.status] || b.status}</span></span>
                <span className="bcast-row__ch">{[b.send_telegram && 'TG', b.send_email && '✉'].filter(Boolean).join(' · ') || '—'}</span>
                <span className="t-caption">{b.audience_display}</span>
                <span className="t-caption">{b.status === 'draft' ? '—' : `${b.sent_count}/${b.planned_recipients} (${b.progress}%)`}</span>
                <span className="t-caption">{fmtDate(b.scheduled_for || b.created_at)}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      {drawer && (
        <BroadcastFormDrawer broadcastId={drawer.id} onClose={closeDrawer} onChanged={refresh} />
      )}
    </div>
  );
}

export { BroadcastsScreen };
